import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import {
  FormGroup,
  ControlLabel,
  Button
} from 'react-bootstrap';
import SelectFieldComponent from '../Common/FormField/SelectFieldComponent';
import messages from '../../locale/messages';

import s from './ListPlaceStep1.css';
import bt from '../../components/commonStyle.css';

class RoomBedsInput extends Component {
  static propTypes = {
    roomNumber: PropTypes.number.isRequired,
    roomType: PropTypes.string.isRequired,
    beds: PropTypes.array.isRequired,
    bedTypeOptions: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    onRemoveBed: PropTypes.func,
  };

  handleBedTypeChange = (bedIndex, event) => {
    const { beds, onChange } = this.props;
    const value = event.target ? event.target.value : event;
    const updatedBeds = [...beds];
    updatedBeds[bedIndex] = {
      ...updatedBeds[bedIndex],
      bedType: parseInt(value)
    };
    onChange(updatedBeds);
  };

  handleBedCountChange = (bedIndex, increment) => {
    const { beds, onChange } = this.props;
    const updatedBeds = [...beds];
    const currentCount = updatedBeds[bedIndex].count || 1;
    const newCount = Math.max(1, currentCount + increment);

    updatedBeds[bedIndex] = {
      ...updatedBeds[bedIndex],
      count: newCount
    };
    onChange(updatedBeds);
  };

  handleAddBed = () => {
    const { beds, bedTypeOptions, onChange } = this.props;
    const defaultBedType = bedTypeOptions.length > 0 ? bedTypeOptions[0].value : null;

    onChange([...beds, { bedType: defaultBedType, count: 1 }]);
  };

  handleRemoveBed = (bedIndex) => {
    const { beds, onChange } = this.props;
    const updatedBeds = beds.filter((_, index) => index !== bedIndex);
    onChange(updatedBeds);
  };

  render() {
    const { roomNumber, roomType, beds, bedTypeOptions } = this.props;

    const roomTitle = roomType === 'shared_space'
      ? <FormattedMessage {...messages.sharedSpaces} />
      : <FormattedMessage {...messages.bedroomNumber} values={{ number: roomNumber }} />;

    return (
      <div className={cx(s.space4, s.roomSection)} style={{ marginBottom: '30px', paddingBottom: '30px', borderBottom: '1px solid #dce0e0' }}>
        <h5 className={s.space3} style={{ fontSize: '16px', fontWeight: '600', color: '#484848', marginBottom: '15px' }}>
          {roomTitle}
        </h5>

        {beds && beds.map((bed, bedIndex) => {
          // Get already selected bed types in this room (excluding current bed)
          const selectedBedTypes = beds
            .map((b, idx) => idx !== bedIndex ? b.bedType : null)
            .filter(type => type !== null);

          // Filter out already selected bed types for this dropdown
          const availableOptions = bedTypeOptions.map(option => ({
            ...option,
            disabled: selectedBedTypes.includes(option.value)
          }));

          return (
            <div key={bedIndex} className={cx(s.space2, s.bedRow)}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
                <div style={{ flex: '1', minWidth: '200px', maxWidth: '80%' }}>
                  <SelectFieldComponent
                    input={{
                      value: bed.bedType,
                      onChange: (event) => this.handleBedTypeChange(bedIndex, event)
                    }}
                    meta={{ touched: false, error: null }}
                    inputClass={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
                    options={availableOptions}
                  />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <Button
                    className={cx(bt.btnPrimary, s.btnSmall)}
                    onClick={() => this.handleBedCountChange(bedIndex, -1)}
                    disabled={bed.count <= 1}
                  >
                    -
                  </Button>
                  <span style={{ fontSize: '16px', fontWeight: '500', minWidth: '30px', textAlign: 'center' }}>{bed.count || 1}</span>
                  <Button
                    className={cx(bt.btnPrimary, s.btnSmall)}
                    onClick={() => this.handleBedCountChange(bedIndex, 1)}
                  >
                    +
                  </Button>
                </div>

                {beds.length > 1 && (
                  <Button
                    className={cx(bt.btnPrimaryBorder)}
                    onClick={() => this.handleRemoveBed(bedIndex)}
                  >
                    <FormattedMessage {...messages.remove} />
                  </Button>
                )}
              </div>
            </div>
          );
        })}

        <div className={s.space3}>
          <Button
            className={cx(bt.btnPrimary)}
            onClick={this.handleAddBed}
          >
            <FormattedMessage {...messages.addBed} />
          </Button>
        </div>
      </div>
    );
  }
}

export default withStyles(s, bt)(RoomBedsInput);
